<rlst-modal header="Disclaimer Info" (closeModal)="dialogRef.close()" *ngIf="disclaimer$ | async as disclaimer">
  <div class="content">
    <div>
      <div *ngFor="let disclaimerItem of disclaimer">
        <h3 class="mb-2">{{ disclaimerItem.heading }}</h3>
        <p>{{ disclaimerItem.content }}</p>
      </div>
    </div>
  </div>

  <div class="actions-panel d-flex">
    <div class="flex-spacer"></div>
    <button (click)="dialogRef.close()" class="btn-custom btn-custom-outline-blue-dark cancel-button">Close</button>
  </div>
</rlst-modal>
